"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLeaderboardsGamesList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns MasochistME games leaderboards.
 *
 * TODO description
 *
 * @param params.filter - Filter to apply to leaderboards list.
 * @param params.sort - Fields to sort leaderboards by.
 * @param params.limit - How many leaderboard entries will get returned.
 */
const getLeaderboardsGamesList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/leaderboards/games/list`;
    const leaderboardsResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = leaderboardsResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getLeaderboardsGamesList = getLeaderboardsGamesList;
